import { memo, useCallback, useContext, useLayoutEffect, useRef } from "react";
import { WizardContext, WizardStepContext } from "../Wizard.Parts";
import { Props } from "./WizardPage.Parts";

export const WizardPage = memo(
  ({
    children,
    title,
    subtitle,
    canContinue,
    canGoBack,
    continueButtonText,
    actions,
    onContinue,
    onBack,
    preRender,
  }: Props) => {
    const ctx = useContext(WizardContext);
    const { isActive } = useContext(WizardStepContext);

    const onContinueRef = useRef(onContinue);
    onContinueRef.current = onContinue;

    const stableOnContinue = useCallback(() => onContinueRef.current?.(), []);

    const onBackRef = useRef(onBack);
    onBackRef.current = onBack;

    const stableOnBack = useCallback(() => onBackRef.current?.(), []);
    const hasOnBack = Boolean(onBack);

    const resolvedCanContinue =
      typeof canContinue === "function" ? canContinue() : canContinue;

    useLayoutEffect(() => {
      if (!isActive) return;
      ctx?.reportConfig({
        title,
        subtitle,
        canContinue: resolvedCanContinue,
        canGoBack,
        continueButtonText,
        actions,
        onContinue: stableOnContinue,
        onBack: hasOnBack ? stableOnBack : undefined,
      });
    }, [
      ctx,
      isActive,
      title,
      subtitle,
      resolvedCanContinue,
      canGoBack,
      continueButtonText,
      actions,
      stableOnContinue,
      hasOnBack,
      stableOnBack,
    ]);

    if (!isActive && !preRender) return null;

    return children;
  },
);
